module.exports = __webpack_public_path__ + "img/banner-servicos.86a86e39.jpg";